import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/settings/assignPrivileges/main"));

const AssignPrivileges = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default AssignPrivileges;


